import { render, staticRenderFns } from "./AmenitiesListCapacitor.vue?vue&type=template&id=522cfd4e&"
import script from "./AmenitiesListCapacitor.vue?vue&type=script&lang=js&"
export * from "./AmenitiesListCapacitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports